/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useCallback } from "react";

export const useKeyAction = (
  keys: string[],
  callback: (...args: any[]) => void,
) => {
  const handleKeyAction = useCallback(
    (e: React.KeyboardEvent, ...args: any[]) => {
      if (keys.includes(e.key)) {
        e.preventDefault();
        callback(...args);
      }
    },
    [callback, keys],
  );

  return { handleKeyAction };
};

export const useEnterAction = (callback: () => void) => {
  return useKeyAction(["Enter", " "], callback);
};
